import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/site";

const NAV_LINKS = [
  { to: "/products", label: "Products", testid: "nav-products-link" },
  { to: "/#features", label: "Our Advantage", testid: "nav-advantage-link" },
  { to: "/#faq", label: "FAQ", testid: "nav-faq-link" },
  { to: "/about", label: "About Us", testid: "nav-about-link" },
  { to: "/contact", label: "Contact Us", testid: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
            <div className="w-9 h-9 bg-blue-700 rounded-md flex items-center justify-center text-white font-black text-sm tracking-wider">
              SE
            </div>
            <div>
              <span className="text-lg font-black tracking-tight text-slate-950 block leading-tight">
                {BUSINESS.name}
              </span>
              <span className="text-[11px] font-bold text-blue-700 tracking-wide block">{BUSINESS.tag}</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-7 text-xs font-bold uppercase tracking-wider text-slate-600">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={l.testid} className="hover:text-blue-700 transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              data-testid="nav-cta-button"
              className="hidden sm:inline-flex items-center justify-center px-4 py-2 text-xs font-bold uppercase tracking-wider text-white bg-blue-700 hover:bg-blue-600 rounded transition-colors shadow-sm"
            >
              Call or WhatsApp
            </Link>
            <button
              type="button"
              data-testid="mobile-menu-button"
              onClick={() => setOpen(!open)}
              className="md:hidden p-2 text-slate-700 hover:text-blue-700 transition-colors"
              aria-label="Toggle menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <nav className="md:hidden pb-5 flex flex-col gap-1 text-sm font-bold uppercase tracking-wider text-slate-700" data-testid="mobile-menu">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className="py-2.5 border-b border-slate-100 hover:text-blue-700 transition-colors"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-nav-cta-button"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center px-4 py-3 text-xs font-bold uppercase tracking-wider text-white bg-blue-700 hover:bg-blue-600 rounded transition-colors"
            >
              Call or WhatsApp
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};
